export const DASHBOARD_PAGE = "/dashboard";
export const DASHBOARD_FOLDER_PAGE = "/dashboard/";
export const SEARCH_ON_MAP_PAGE = "/dashboard-with-map";
export const START_NEW_PROJECT_PAGE = "/start-new-project";
export const UPDATE_PROJECT_ACCESS_PAGE = "/update-project-access";
